import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Col, Container, Row} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'

import s from './Make1099Exceptions.module.scss'
const cx = cn.bind(s)

interface IMake1099ExceptionsProps {
	className?: string
	content: IMake1099Content['exceptions']
}

/** Make1099Exceptions block component */
const Make1099Exceptions: FC<IMake1099ExceptionsProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} subtitle={content?.description} />
				<Row>
					<Col lg={{span: 10, offset: 1}} xl={{span: 8, offset: 2}}>
						<div className={s.blocks}>
							{content?.items?.leftList && (
								<PortableBlocks blockContent={content?.items?.leftList} />
							)}
							{content?.items?.rightList && (
								<PortableBlocks blockContent={content?.items?.rightList} />
							)}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

Make1099Exceptions.displayName = 'Make1099Exceptions'

export default Make1099Exceptions
